import moment from "moment";

angular
  .module("AccountingBoxApp")
  .controller("CompaniesEditCtrl", function(
    $scope,
    $rootScope,
    $stateParams,
    $state,
    $http,
    Company,
    User
  ) {
    var vm = this;
    var company;

    vm.bookkeepers = []

    $rootScope.getBookkeepers().then((bookkeepers)=> {
      console.log('bookkeepers',bookkeepers);
      vm.bookkeepers = bookkeepers
    })



    vm.popupCenter = function(url, title, w, h) {
      h = window.screen.height;
      w = window.screen.width * 0.6;
      var left = window.screen.width / 2 - w / 2;
      var top = window.screen.height / 2 - h / 2;
      top = 0;
      return window.open(
        url,
        title,
        "toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=" +
          w +
          ", height=" +
          h +
          ", top=" +
          top +
          ", left=" +
          left
      );
    }

    vm.onCompanySelect = function(company) {
      // vm.company = _.assign(vm.company, company);
      vm.updateCompanyInfo(company);
    };

    vm.save = function(company, form) {
      console.log('form valid',form.$valid);
      console.log('form ',form);
      $scope.submitted = true;
      company.bookkeeperId = company.bookkeeper?.id || null;
      company.taxAdvisorId = company.taxAdvisor?.id || null;

      company.foundationDate = moment(
          vm.foundationDate,
          "DD-MM-YYYY"
        ).toDate();
      console.log('vm.startDate save is',vm.startDate);
        company.startDate = vm.startDate && vm.startDate.length > 0 ?  moment(vm.startDate, "MMMM YYYY").startOf('month').toDate() : null;
        company.endDate = vm.endDate && vm.endDate.length>0 ? moment(vm.endDate, "MMMM YYYY").endOf('month').toDate() : null;
        console.log("Saving company", company);

        company = new Company(company);
        company.$save().then(function() {
          $scope.submitted = false;
          window.location.reload();
          $scope.$emit("companySaved", company);
        }
      ).catch(function(err) {
        console.log('err',err);
      });

        Company.users.updateById(
          {
            id: company.id,
            fk: company.users[0].id
          },
          company.users[0]);
    };

    vm.activate = function(company) {
      Company.activate({ id: company.id }).$promise.then(function() {
        $scope.$emit("companySaved", company);
      });
    };

    vm.deactivate = function(company) {
      console.log("deactivate");
      Company.deactivate({ id: company.id }).$promise.then(function() {
        $scope.$emit("companySaved", company);
      });
    };

    vm.pricingModels = [1, 2, 3, 4, 5];

    vm.numberOfPartners = [2, 3, 4, 5];
    vm.numberOfEmployees = [
      0,
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20
    ];

    vm.startingDates = []
    vm.endDates =[]
    vm.dates = []
    for(let i = 0; i < 4; i++) {
      const d = moment().startOf('month').add(4-i, 'months')
      const v = d.format('MMMM YYYY')
      vm.dates.push(v)
    }
    for (let i = 0; i < 12*10; i++) {
      const d = moment().startOf('month').subtract(i, 'months')
      const v = d.format('MMMM YYYY')
      vm.dates.push(v)
    }

    vm.endDates = [...vm.dates]
    vm.startingDates = [...vm.dates];
    vm.endDates.unshift('')
    vm.startingDates.unshift('')

    vm.vatPeriods = [
      {
        description: "Per jaar",
        value: "YEARLY"
      },
      {
        description: "Per kwartaal",
        value: "QUARTERLY"
      },
      {
        description: "Per maand",
        value: "MONTHLY"
      },
      {
        description: "Vrijgesteld",
        value: "EXEMPTED"
      },
      {
        description: "KOR",
        value: "EXEMPTED_KOR"
      },
    ];

    vm.businessTypes = [
      {
        value: "Eenmanszaak",
        description: "Eenmanszaak (ZZP'er)"
      },
      {
        value: "V.O.F.",
        description: "V.O.F."
      },
      {
       value: 'B.V.',
       description: 'B.V.'
    }
    ];

    vm.updateMaximumBankTransactionsPerQuarterOptions =() => {

      vm.maximumBankTransactionsPerQuarterOptions  =  [
        30,
        75,
        150,
        250,
        375,
        500,
        750,
        1000,
        1250,
        1500,
        1750,
        2000,
        2250,
        2500
      ]

      vm.maximumBankTransactionsPerQuarterOptions = vm.maximumBankTransactionsPerQuarterOptions.map(value => ({
          label: `Tot ${value} per kwartaal (${value*4} p/jr)`,
            value,
        }));

      if (vm.company && vm.company.businessType === "B.V.") {
        vm.maximumBankTransactionsPerQuarterOptions[0].label =
          "Beheer B.V. tot 30 per kwartaal (120 p/jr)";
      }
      if($rootScope.isBookkeeper()) {
        vm.maximumBankTransactionsPerQuarterOptions.unshift({label: 'Geen', value: 0})
      }
    };

    vm.numberOfIncomeTaxReturns = [1];

    vm.updateSubscriptions = function() {
      vm.updateMaximumBankTransactionsPerQuarterOptions();
      vm.oldSubscriptions = [
        {
          maximalNumber: 75,
          description: "Tot 75 inkoopfacturen / verkoopfacturen / bonnetjes"
        },
        {
          maximalNumber: 150,
          description: "Tot 150 inkoopfacturen / verkoopfacturen / bonnetjes"
        },
        {
          maximalNumber: 250,
          description: "Tot 250 inkoopfacturen / verkoopfacturen / bonnetjes"
        },
        {
          maximalNumber: 400,
          description: "Tot 400 inkoopfacturen / verkoopfacturen / bonnetjes"
        },
        {
          maximalNumber: 600,
          description: "Tot 600 inkoopfacturen / verkoopfacturen / bonnetjes"
        },
        {
          maximalNumber: 800,
          description: "Tot 800 inkoopfacturen / verkoopfacturen / bonnetjes"
        },
        {
          maximalNumber: 1000,
          description: "Tot 1000 inkoopfacturen / verkoopfacturen / bonnetjes"
        },
        {
          maximalNumber: 1250,
          description: "Tot 1250 inkoopfacturen / verkoopfacturen / bonnetjes"
        },
        {
          maximalNumber: 1500,
          description: "Tot 1500 inkoopfacturen / verkoopfacturen / bonnetjes"
        },
        {
          maximalNumber: 2000,
          description: "Tot 2000 inkoopfacturen / verkoopfacturen / bonnetjes"
        },
        {
          maximalNumber: 2500,
          description: "Tot 2500 inkoopfacturen / verkoopfacturen / bonnetjes"
        },
        {
          maximalNumber: 3000,
          description: "Tot 3000 inkoopfacturen / verkoopfacturen / bonnetjes"
        },
        {
          maximalNumber: 3500,
          description: "Tot 3500 inkoopfacturen / verkoopfacturen / bonnetjes"
        },
        {
          maximalNumber: 4000,
          description: "Tot 4000 inkoopfacturen / verkoopfacturen / bonnetjes"
        },
        {
          maximalNumber: 4500,
          description: "Tot 4500 inkoopfacturen / verkoopfacturen / bonnetjes"
        },
        {
          maximalNumber: 5000,
          description: "Tot 5000 inkoopfacturen / verkoopfacturen / bonnetjes"
        }
      ];

      if (vm.company && vm.company.businessType === "B.V.") {
        /*  vm.oldSubscriptions.unshift( { maximalNumber: 50,
                 description: 'Tot 50 (Beheer / Pensioen / Management B.V.)'
                 });*/
        vm.oldSubscriptions[0].description =
          "Beheer / Pensioen / Management B.V. (Tot 50)";
        vm.oldSubscriptions[0].maximalNumber = 50;
      }


    };


    vm.onPricingModelChange = function(company) {
      vm.onBusinessTypeChange(company);
    };

    vm.onBusinessTypeChange = function(company) {
      if(vm.company && vm.company.pricingModel > 1) {
        if(vm.company.businessType === "B.V.") {
          vm.numberOfIncomeTaxReturns = [0, 1, 2, 3];
            company.numberOfIncomeTaxReturns = 0;
        }else if(vm.company.businessType === "V.O.F.") {
          vm.numberOfIncomeTaxReturns = [2, 3, 4, 5];
            company.numberOfIncomeTaxReturns = 2;
        }else {
          vm.numberOfIncomeTaxReturns = [1];
          company.numberOfIncomeTaxReturns = 1;
        }
      }
      vm.updatePrice(company);
    };

    vm.resetPassword = function(user) {
      var options = {
        email: user.email
      };
      User.resetPassword(options);
    };


    vm.updatePrice = function(company) {
      vm.updateSubscriptions();
      if(company.pricingModel > 1) {
        vm.updatePriceWithNewPricingModel(company);
      }else {
        vm.updatePriceWithOldPricingModel(company);
      }
    };

    vm.updatePriceWithNewPricingModel = function(company) {
      let price = 0;
      if(!company.businessType) return;
      if(company.maximumBankTransactionsPerQuarter === undefined) return;
      if(company.numberOfIncomeTaxReturns===undefined) {
        company.numberOfIncomeTaxReturns = 1;
      }
      let numberOfExtraIncomeTaxReturns = 0;

      let priceTable = {
        2: {
          0: 0,
          30: 39,
          75: 54,
          150: 74,
          250: 99,
          375: 124,
          500: 149,
          750: 199,
          1000: 249,
          1250: 299,
          1500: 349,
          1750: 399,
          2000: 449,
          2250: 499,
          2500: 549
      },
        3: {
          0: 0,
          30: 44,
          75: 59,
          150: 84,
          250: 109,
          375: 134,
          500: 164,
          750: 219,
          1000: 274,
          1250: 329,
          1500: 384,
          1750: 439,
          2000: 494,
          2250: 549,
          2500: 604
        },
        4: {
          0: 0,
          30: 49,
          75: 64,
          150: 89,
          250: 119,
          375: 149,
          500: 179,
          750: 239,
          1000: 299,
          1250: 369,
          1500: 419,
          1750: 479,
          2000: 539,
          2250: 599,
          2500: 659
        },
        5: {
          0: 0,
          30: 54,
          75: 69,
          150: 94,
          250: 124,
          375: 159,
          500: 194,
          750: 254,
          1000: 314,
          1250: 374,
          1500: 434,
          1750: 494,
          2000: 554,
          2250: 614,
          2500: 674
        }
    };

      if (company.businessType.match(/V.O.F.|Eenmanszaak/i)) {
        numberOfExtraIncomeTaxReturns = Math.max(0, (company.numberOfIncomeTaxReturns - 1));
      }

      if(company.businessType.match("B.V.")) {
        numberOfExtraIncomeTaxReturns = company.numberOfIncomeTaxReturns;
        priceTable = {
          0: 0,
          30: 49,
          75: 99,
          150: 129,
          250: 149,
          375: 179,
          500: 209,
          750: 269,
          1000: 329,
          1250: 389,
          1500: 449,
          1750: 509,
          2000: 569,
          2250: 629,
          2500: 689
        };
        if(company.pricingModel === 5) {
          priceTable = {
            0: 0,
            30: 54,
            75: 109,
            150: 134,
            250: 164,
            375: 199,
            500: 229,
            750: 289,
            1000: 349,
            1250: 409,
            1500: 469,
            1750: 529,
            2000: 589,
            2250: 649,
            2500: 709
          };
        }
        price += priceTable[company.maximumBankTransactionsPerQuarter.toString()];
      }else {
        price += priceTable[company.pricingModel][company.maximumBankTransactionsPerQuarter.toString()];
      }

      const MONTHLY_PAYROLL_PRICE  = company.pricingModel === 5 ? 13 : 12;
      price += company.numberOfEmployees * MONTHLY_PAYROLL_PRICE;

      const MONTHLY_EXTRA_INCOME_TAX_RETURN_PRICE = company.pricingModel === 5 ? 13 : 10;
      price +=  numberOfExtraIncomeTaxReturns * MONTHLY_EXTRA_INCOME_TAX_RETURN_PRICE;

      const MONTHLY_ONE_STOP_SHOP_PRICE = company.pricingModel === 5 ? 10 : 7.5;
      price += (company.oneStopShopReturn || 0) * MONTHLY_ONE_STOP_SHOP_PRICE;

      if(company.discount) {
        price -= company.discount;
      }

      company.monthlySubscriptionPrice = price;
      return company;
    };

    vm.updatePriceWithOldPricingModel = function(company) {
      var p = 0;
      if (company.businessType === "B.V.") {
        switch (company.maximalInvoicesSubscription) {
          case 50:
            p = 75;
            break;
          case 150:
            p = 120;
            break;
          case 250:
            p = 135;
            break;
          case 400:
            p = 160;
            break;
          case 600:
            p = 190;
            break;
          case 800:
            p = 220;
            break;
          case 1000:
            p = 250;
            break;
          case 1250:
            p = 290;
            break;
          case 1500:
            p = 330;
            break;
          case 2000:
            p = 400;
            break;
          case 2500:
            p = 475;
            break;
          case 3000:
            p = 550;
            break;
          case 3500:
            p = 625;
            break;
          case 4000:
            p = 700;
            break;
          case 4500:
            p = 775;
            break;
          case 5000:
            p = 850;
            break;
          default:
            p = 120;
            break;
        }
      } else {
        switch (company.maximalInvoicesSubscription) {
          case 75:
            p = 40;
            break;
          case 150:
            p = 50;
            break;
          case 250:
            p = 70;
            break;
          case 400:
            p = 95;
            break;
          case 600:
            p = 130;
            break;
          case 800:
            p = 165;
            break;
          case 1000:
            p = 200;
            break;
          case 1250:
            p = 240;
            break;
          case 1500:
            p = 280;
            break;
          default:
            p = 40;
            break;
        }
      }

      // console.log('update price: nubmerparnets:'+company.numberOfPartners + 'bysinesstype: '+company.businessType);
      if (company.businessType === "V.O.F.") {
        if (!company.numberOfPartners) {
          company.numberOfPartners = 2;
        }

        p += (company.numberOfPartners - 1) * 10;
      } else {
        company.numberOfPartners = 0;
      }
      if (company.businessType === "B.V.") {
        p -= 16;
        if (company.numberOfEmployees > 0) {
          p += 16;
          p += (company.numberOfEmployees - 1) * 11.75;
        }
      } else if (company.numberOfEmployees > 0) {
        p += 16;
        p += (company.numberOfEmployees - 1) * 11.75;
      }
      company.monthlySubscriptionPrice = p;
      vm.updateKvkStarterDiscount();
    };

    $scope.$watch(
      "ce.company.foundationDate",
      function(newValue, oldValue) {
        vm.updateKvkStarterDiscount();
      },
      true
    );
    vm.updateKvkStarterDiscount = function() {
      if (vm.company) {
        vm.company.starterDiscount = 0;
        if (vm.company.maximalInvoicesSubscription && vm.foundationDate) {
          var kD = moment(vm.foundationDate, "DD-MM-YYYY")
            .add(12, "months")
            .toDate();
          var today = new Date();
          if (kD > today && vm.company.pricingModel <= 1) {
            vm.company.starterDiscount = 10;
          }
        }
      }
      // console.log('kd is:', kD);

      // body...
    };
    vm.generateAuthorizationReference = function(company) {
      if (company.mandateSigned) {
        company.mandateReference = moment(vm.company.registrationDate).format('YYYYDDMM') + (vm.company.companyRegistrationNumber || vm.company.name?.toLowerCase().replaceAll(' ','') || '_________');
      }
    };
    /*vm.removeModal = function() {
         $('#removeModal').modal('show');
         };
         vm.remove = function(){
         $('#removeModal').modal('hide');
         Company.deleteById({
         id: company.id
         }).$promise.then(function() {
         console.log('deleted company');
         scope.$emit('vendorRemoved');
         //   vm.returnToList();
         });
         };*/
    $scope.options = {
      language: "nl",
      todayHighlight: true,
      format: "dd-mm-yyyy",
      autoclose: true
    };

    $scope.startDateOptions = {
      language: "nl",
      todayHighlight: true,
      format: "MM yyyy",
      startView: 1,
      minViewMode: 1,
      autoclose: true
      /* beforeShowDay: function (date) {
             // console.log('showbefor day date:', date.getDate());
             if (date.getDate() == 1) {
             //console.log('date return true', date);
             return [true, 'enabled'];
             }
             return [false, 'disabled'];
             }*/
    };
    $scope.$on("editCompany", function(e, company) {
      /* company = Company.get({
             id: company.id
             });*/
      console.log("edit company: ", company);
      vm.company = company;

      if ((!vm.company.registrationDate) || vm.company.demo) {
        vm.company.newPricingModel = true;
        vm.company.pricingModel = 5;
      }
      if (!vm.company.registrationDate && vm.company?.invoiceSettings) {
        vm.company = {...vm.company, ...vm.company.invoiceSettings.companyInformation}
      }
      if (!vm.company.registrationDate) {
        vm.company.registrationDate = new Date();
      }
        // vm.selectedCompany = {};
      // vm.selectedCompany.suggest = company.name;
      // $(".ui-select-companies input.form-control.ui-select-search")[0].value =
      //   company.name;
      $("#foundationDatePicker").datepicker($scope.options);
      if (company.foundationDate) {
        $("#foundationDatePicker").datepicker(
          "setDate",
          moment(company.foundationDate).format("DD-MM-YYYY")
        );
        vm.foundationDate = moment(company.foundationDate).format("DD-MM-YYYY");
      }

      // $("#startDatePicker").datepicker($scope.startDateOptions);
      // $("#endDatePicker").datepicker($scope.startDateOptions);
      let startDate = moment().startOf('month').toDate()
      // //console.log('startdate is:',startDate);
      if (company.startDate) {
        startDate = company.startDate;
      }
      // $("#startDatePicker").datepicker(
      //   "setDate",
      //   moment(startDate).format("MMMM YYYY")
      // );
      vm.startDate = moment(startDate).format("MMMM YYYY");


      vm.endDate = '';
      if(company.endDate){
        vm.endDate = moment(company.endDate).format("MMMM YYYY");
        // $("#endDatePicker").datepicker(
        //   "setDate",
        //   moment(vm.endDate).format("MMMM YYYY")
        // );
      }

      if (!company.numberOfEmployees) {
        company.numberOfEmployees = 0;
      }

      if (!company.registrationDate) {
        vm.refreshCompaniesList(company.name);
      }

      vm.updateSubscriptions();
    });

    //kvk suggestion
    /*vm.updateCompanyInfo = function(list) {
         var item;
         list.forEach(function(company) {
         if (company.type === "Hoofdvestiging" && !item) {
         item = company;
         }
         });
         if (!item) {
         item = list[0];
         }
         vm.company.name = item.handelsnaam;
         if (!vm.company.address) {
         vm.company.address = {};
         }
         vm.company.address.line1 = item.straat + ' ' + item.huisnummer;

         if (item.huisnummertoevoeging > 0) {
         vm.company.address.line1 += '-' + item.huisnummertoevoeging;
         }
         vm.company.address.postalCode = item.postcode;
         vm.company.address.city = item.plaats;
         vm.company.companyRegistrationNumber = item.dossiernummer;
         vm.company.businessType = 'Eenmanszaak';
         vm.company.numberOfEmployees = 0;
         if (vm.company.name.toUpperCase().indexOf('B.V.') > -1) {
         vm.company.businessType = 'B.V.';
         if (vm.company.name.toUpperCase().indexOf('BEHEER B.V.') < 0){
         vm.company.numberOfEmployees = 1;
         }else{
         vm.company.maximalInvoicesSubscription = 50;
         }
         }
         if (vm.company.name.toUpperCase().indexOf('V.O.F.') > -1 || vm.company.name.toUpperCase().indexOf('VOF') > -1) {
         vm.company.businessType = 'V.O.F.';
         }
         vm.updatePrice(vm.company);
         vm.getCompaniesLogoList(vm.company.name);

         };*/
    vm.updateCompanyInfo = function(organisation) {
      /*  var item;
             list.forEach(function (company) {
             if(company.type === "Hoofdvestiging" && !item){
             item=company;
             }
             });
             if(!item){
             item = list[0];
             }*/
      vm.company.name = organisation.name;
      vm.company.address = organisation.address;
      if (organisation.bankAccountNumbers) {
        vm.company.bankAccountNumber = organisation.bankAccountNumbers[0];
      }
      vm.company.website = organisation.website || vm.company.website;
      vm.company.companyRegistrationNumber =
        organisation.companyRegistrationNumber;
      vm.company.phone = organisation.phone || vm.company.phone;
      vm.company.vatIdentificationNumber = organisation.vatIdentificationNumber;
      vm.company.companyActivity = organisation.companyActivity;
      // vm.company.email = organisation.email;
      if (organisation.id) {
        vm.company.organisationId = organisation.id;
      }

      if (organisation.foundingDate) {
        $("#foundationDatePicker").datepicker($scope.options);
        vm.company.foundationDate = organisation.foundingDate;
        $("#foundationDatePicker").datepicker(
          "setDate",
          moment(vm.company.foundationDate).format("DD-MM-YYYY")
        );
        vm.foundationDate = moment(vm.company.foundationDate).format(
          "DD-MM-YYYY"
        );
      }
      vm.company.businessType = organisation.businessType || "Eenmanszaak";
      vm.company.numberOfEmployees = 0;
      if (vm.company.name.toUpperCase().indexOf("B.V.") > -1) {
        vm.company.businessType = "B.V.";
        if (vm.company.name.toUpperCase().indexOf("BEHEER B.V.") < 0) {
          vm.company.numberOfEmployees = 1;
        } else {
          vm.company.maximalInvoicesSubscription = 50;
        }
      }
      if (
        vm.company.name.toUpperCase().indexOf("V.O.F.") > -1 ||
        vm.company.name.toUpperCase().indexOf("VOF") > -1
      ) {
        vm.company.businessType = "V.O.F.";
      }
      vm.updatePrice(vm.company);
      // vm.getCompaniesLogoList(vm.company.name);
      //vm.getCompaniesLogoList(vm.contact.companyName);
    };
    /* vm.companySelect = function(item, model) {
         if (item && item.url && !$scope.kvk) {
         var companyRegistrationNumber = item.url.split('/')[0];
         $http.get('https://zoeken.kvk.nl/JsonSearch.ashx?handelsnaam=&kvknummer=' + companyRegistrationNumber + '&hoofdvestiging=true&rechtspersoon=false&nevenvestiging=false&zoekvervallen=0&zoekuitgeschreven=0&start=0&searchfield=uitgebreidzoeken&advanced=1').then(
         function(response) {
         if (response.data.entries.length > 0) {
         vm.updateCompanyInfo(response.data.entries);
         // $scope.multipleDemo.colors = ['Blue','Red'];
         } else {
         $http.get('https://zoeken.kvk.nl/JsonSearch.ashx?q=' + companyRegistrationNumber).then(function(response2) {
         vm.updateCompanyInfo(response2.data.entries);
         });
         }
         },
         function(response) {
         console.log('Error loading kvk companies', response);
         }
         );
         } else if (item && item.handelsnaam) {
         vm.updateCompanyInfo([item]);
         } else {
         var name = $('.ui-select-companies input.form-control.ui-select-search')[0].value;
         // console.log('no url tag:',name);
         vm.company.name = name;
         vm.selectedCompany = {};
         vm.selectedCompany.selected = {
         suggest: name
         };
         $scope.$apply();
         vm.getCompaniesLogoList(vm.company.name);
         }
         };*/
    vm.companySelect = function(item, model) {
      // console.log("item: ", item);
      if (item.AccountingBox) {
        vm.updateCompanyInfo(item);
      } else if (item.KvK) {
        vm.updateCompanyInfo(item);
        $http
          .get(
            API_ENDPOINT +
              "/Organisations/kvk/?companyRegistrationNumber=" +
              item.companyRegistrationNumber +
              "&companyName=" +
              item.name
          )
          .then(function(response) {
            vm.updateCompanyInfo(response.data.organisation);
          });
      } else {
        vm.company.name = item.name;
      }
    };
    vm.logoListSuggest = function(query, cb) {
      $http
        .get(
          "https://autocomplete.clearbit.com/v1/companies/suggest?query=" +
            query
        )
        .then(
          function(response) {
            //  console.log('response:', response);
            cb(response.data);
          },
          function(response) {
            cb();
            console.log("Error loading companies logo list!");
          }
        );
    };

    vm.getDutchCompany = function(list, query) {
      var dc;
      var stop = false;
      list.forEach(function(company) {
        var splitted = company.domain.split(".");
        //console.log('company:',company.name.toLowerCase().replace(/ /g, ''));
        // console.log('query:',query.toLowerCase().replace(/ /g, ''));

        if (
          !stop &&
          company.name &&
          company.name.toLowerCase().replace(/ /g, "") ===
            query.toLowerCase().replace(/ /g, "")
        ) {
          dc = company;
          stop = true;
          console.log("EQUALS");
        }
        //console.log('splited: ', splitted[splitted.length - 1]);
        if (splitted[splitted.length - 1] === "nl" && !dc && !stop) {
          dc = company;
        }
      });
      if (!dc) {
        dc = list[0];
      }
      return dc;
      // body...
    };

    vm.getCompaniesLogoList = function(query) {
      var query1 = query.replace("B.V.", "").replace("N.V.", "");
      vm.logoListSuggest(query1, function(list) {
        // console.log('callback');
        if (list && list.length > 0) {
          vm.companyLogoUrl = vm.getDutchCompany(list, query1).logo;
          vm.company.website = vm.getDutchCompany(list, query1).domain;
        } else {
          var query2 = query.split(" ")[0] + " " + query.split(" ")[1];
          vm.logoListSuggest(query2, function(list2) {
            if (list2 && list2.length > 0) {
              vm.companyLogoUrl = vm.getDutchCompany(list2, query2).logo;
              vm.company.website = vm.getDutchCompany(list2, query2).domain;
            } else {
              var query3 = query.split(" ")[0];
              vm.logoListSuggest(query3, function(list3) {
                vm.companyLogoUrl = vm.getDutchCompany(list3, query3).logo;
                vm.company.website = vm.getDutchCompany(list3, query3).domain;
              });
            }
          });
        }
      });
    };

    vm.companyGroup = function(company) {
      //  compan
      if (company.AccountingBox) {
        return "AccountingBox";
      } else {
        return "KvK";
      }
    };

    vm.onSearchQueryChange = _.debounce(function(query) {
      vm.refreshCompaniesList(query);
    }, 300);

    vm.refreshCompaniesList = function(query) {
      //  console.log('refresh');

      //var url = 'https://openkvk.nl/suggest/' + query + '?callback=JSON_CALLBACK';

      /*$http.jsonp(url)
             .then(function(json) {
             alert(json.data.data);
             });*/

      //$.getJSON(url, config).success(callback
      //http://zoeken.kvk.nl/JsonSearch.ashx?q=
      //http://zoeken.kvk.nl/JsonSearch.ashx?handelsnaam=itupt&kvknummer=&hoofdvestiging=true&rechtspersoon=false&nevenvestiging=false&zoekvervallen=0&zoekuitgeschreven=0&start=0&searchfield=uitgebreidzoeken&advanced=1
      /* $http({
             method: 'JSONP',
             url: ('https://openkvk.nl/suggest/' + query)
             }).then(*/
      if (query.length > 1) {
        /* if (!$scope.kvk) {
                 $http.get('https://crossorigin.me/https://openkvk.nl/suggest/' + query).then(
                 // $http.get('https://crossorigin.me/http://zoeken.kvk.nl/JsonSearch.ashx?handelsnaam='+query+'&kvknummer=&hoofdvestiging=true&rechtspersoon=false&nevenvestiging=false&zoekvervallen=0&zoekuitgeschreven=0&start=0&searchfield=uitgebreidzoeken&advanced=1').then(
                 function(response) {
                 //response.data.unshift('adfadsfadsfadsf');
                 vm.companies = response.data; //.entries;\

                 // $scope.multipleDemo.colors = ['Blue','Red'];
                 },
                 function(response) {
                 console.log('Error loading openkvk companies', response);
                 $scope.kvk = true;
                 vm.refreshCompaniesList(query);
                 }
                 );
                 } else {
                 $http.get('https://zoeken.kvk.nl/JsonSearch.ashx?handelsnaam=' + query + '&kvknummer=&hoofdvestiging=true&rechtspersoon=false&nevenvestiging=false&zoekvervallen=0&zoekuitgeschreven=0&start=0&searchfield=uitgebreidzoeken&advanced=1' + query).then(
                 // $http.get('http://zoeken.kvk.nl/JsonSearch.ashx?handelsnaam='+query+'&kvknummer=&hoofdvestiging=true&rechtspersoon=false&nevenvestiging=false&zoekvervallen=0&zoekuitgeschreven=0&start=0&searchfield=uitgebreidzoeken&advanced=1').then(
                 function(response) {
                 vm.companies = response.data.entries; //.entries;\
                 vm.companies.unshift('dadsf');
                 //  console.log('respone data:', response.data.entries);
                 // $scope.multipleDemo.colors = ['Blue','Red'];
                 },
                 function(response) {
                 console.log('Error loading kvk companies', response);
                 }
                 );
                 }*/
        $http
          .get(
            API_ENDPOINT +
              "/Organisations/search?query=" +
              encodeURIComponent(query)
          )
          .then(
            // $http.get('https://crossorigin.me/http://zoeken.kvk.nl/JsonSearch.ashx?handelsnaam='+query+'&kvknummer=&hoofdvestiging=true&rechtspersoon=false&nevenvestiging=false&zoekvervallen=0&zoekuitgeschreven=0&start=0&searchfield=uitgebreidzoeken&advanced=1').then(
            function(response) {
              var companies = [];
              /*   response.data.organisations.AccountingBox.forEach(function(company) {
                         company.AccountingBox = true;
                         companies.push(company);
                         });*/
              if (response.data.organisations.KvK) {
                response.data.organisations.KvK.forEach(function(company) {
                  company.KvK = true;
                  companies.push(company);
                });
              }

              companies.push({
                name: query,
                companyRegistrationNumber: "niet uit KVK"
              });
              vm.companies = companies;
            },
            function(response) {
              console.log("Error loading openkvk companies", response);
              // $scope.kvk = true;
              //  vm.refreshCompaniesList(query);
            }
          );
      }
    };
  });
